import { api } from '@/fsd/shared/api';

interface IPaymentResult {
  data: {
    payment_id: string;
    confirmation_url: string;
  };
}

interface IParams {
  tariff_price_id: number;
  promo_code?: string;
}

export const postPayment = async (
  params: IParams
): Promise<IPaymentResult['data']> => {
  const { data } = await api.post<IPaymentResult>('/api/v1/payment/', {
    body: { ...params },
  });

  return data;
};
